import { useEffect, useState } from 'react';
import { ReactComponent as AgendaItemSvg } from '../images/agenda-item.svg';
import { ReactComponent as AddSvg } from '../images/add.svg';
import './logs.css';
import axios from 'axios';
import { SelectButton, Options } from '../components/selectButton';
import { ReactComponent as OptionsSVG } from '../images/options.svg';
import { formatDateToLocale, get, offsetDate, offsetDatetime, post } from './utils/utils';
import { Navigate, useNavigate } from 'react-router-dom';
import userEvent from '@testing-library/user-event';
import { useAuth } from '../context/context';

export interface Log {
  id?: string;
  datetime: Date;
  abstract?: string;
  content?: string;
  signature?: string;
}

export function Logs() {
  const [logs, setLogs] = useState<Log[]>([]);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [content, setContent] = useState<string>('');
  const [filterDate, setFilterDate] = useState<Date>();
  const [filteredLogs, setFilteredLogs] = useState<Log[]>([]);
  const [refetch, setRefetch] = useState<boolean>(true);
  let navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if(filterDate && filterDate.toString() !== 'Invalid Date') {
      const filterLogs = logs.filter((log) => log.datetime.toLocaleDateString() === offsetDate(filterDate).toLocaleDateString())
      setFilteredLogs(filterLogs);
    } else {
      setFilteredLogs(logs);
    }
  }, [filterDate])

  useEffect(() => {
    get({
      url: 'logs.php',
      token: user.token,
    })
      .then((response) => response.data)
      .then((data) => {
        const logs: Log[] = data.map((item: any) => {
          const startDate = new Date(item.datetime);
          const offsetStartDate = offsetDatetime(startDate);
          return {
            id: item.id_log,
            datetime: offsetStartDate,
            abstract: item.abstract,
            content: item.content,
            signature: item.signature
          };
        });
        setLogs(logs);
        setFilteredLogs(logs);
      })
      .catch((error) => {
        console.error('Error fetching items:', error);
      });
  }, [refetch]);

  function addAgendaItem(event: React.SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();
    console.log('required')
    if (content) {
      const newLog: Log = {
        abstract: content,
        datetime: selectedDate,
        content,
      };
      const formData = new FormData();
      formData.append('datetime', newLog.datetime.toISOString().slice(0, 19).replace('T', ' '));
      formData.append('content', newLog.content ?? '');
      formData.append('abstract', newLog.abstract ?? '');
      post({
        url: 'postLog.php',
        data: formData,
        token: user.token,
      })
        .then((response) => response.data)
        .then((data) => {
          if (data.status === 'ok') {
            setContent('');
            setFilterDate(undefined);
            setRefetch(!refetch);
          }
        });
    }
  }

  return (
    <div className="agenda-container">
      <div className='bitacora-header'>
        <div>
          <label htmlFor='date'><b>Fecha exacta:</b></label>
          <input
          aria-label="date"
          id='date'
          type="date"
          className="agenda-input"
          onChange={(event) => setFilterDate(new Date(event.target.value))}
        />
        </div>
      </div>
      <div className="log-items">
        {filteredLogs.map((item: Log) => (
          <div className="log-item" key={item.id}>
            <div className="log-content">
              <p><strong>{formatDateToLocale(item.datetime)} {item.signature ? '| ' + item.signature : ''}</strong></p>
              <p>{item.abstract}</p>
            </div>
            <div className="log-icon clickable" onClick={() => navigate('modificar', { state: item })}>
              <AgendaItemSvg />
            </div>  
          </div>
        ))}
      </div>
      <form className="agenda-new-item" onSubmit={addAgendaItem}>
        <input
          aria-label="Time"
          type="datetime-local"
          className="agenda-input"
          required
          onChange={(event) => setSelectedDate(new Date(event.target.value))}
        />
        <input
          required
          type="text"
          className="agenda-input"
          placeholder="Añadir nueva entrada"
          style={{ flex: 8 }}
          value={content}
          onChange={(event) => setContent(event.target.value)}
        />
        <button type='submit'>
          <AddSvg className="agenda-add-icon" />
        </button>
      </form>
    </div>
  );
}
